import React, { useState, useEffect } from 'react';
import { getPageContent, subscribeToPage } from '../firebase/firebase-config';

function ExaminationSchedule() {
  const [content, setContent] = useState({ title: 'Examination Schedule', session: '2025-26', exams: [], sliderImages: [] });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadData = async () => {
      try { const data = await getPageContent('examinationSchedule'); setContent(data); } catch(e) { console.error(e); }
      finally { setLoading(false); }
    };
    loadData();
    const unsubscribe = subscribeToPage('examinationSchedule', (data) => { if (data) setContent(data); });
    return () => unsubscribe();
  }, []);

  if (loading) return <div className="loading"><div className="spinner"></div></div>;

  return (
    <div className="exam-page">
      <div className="container"><h1 className="page-title">{content.title}</h1><p className="session">Academic Session: {content.session}</p><div className="exam-grid">{(content.exams || []).map((e, idx) => (<div key={idx} className="exam-card"><h3>{e.name}</h3><div className="exam-date">📅 {new Date(e.startDate).toLocaleDateString()} - {new Date(e.endDate).toLocaleDateString()}</div><p><strong>Classes:</strong> {e.classes}</p><p><strong>Timing:</strong> {e.timing}</p>{e.file && <a href={e.file.url} download className="download-btn">📥 Download Schedule</a>}</div>))}</div></div>
      <style>{`
        .exam-page { background: #f8fafc; min-height: 100vh; padding: 60px 0; }
        .container { max-width: 1200px; margin: 0 auto; padding: 0 20px; }
        .page-title { font-size: 36px; color: #1a3a6b; text-align: center; margin-bottom: 10px; }
        .session { text-align: center; color: #64748b; margin-bottom: 40px; }
        .exam-grid { display: grid; grid-template-columns: repeat(auto-fill, minmax(320px, 1fr)); gap: 25px; }
        .exam-card { background: white; border-radius: 16px; padding: 25px; box-shadow: 0 2px 8px rgba(0,0,0,0.1); border-left: 4px solid #f59e0b; }
        .exam-card h3 { color: #1a3a6b; margin-bottom: 10px; }
        .exam-date { color: #f59e0b; font-size: 14px; margin-bottom: 15px; }
        .download-btn { display: inline-block; margin-top: 15px; background: #1a3a6b; color: white; padding: 8px 16px; border-radius: 8px; text-decoration: none; font-size: 13px; }
        .loading { display: flex; justify-content: center; align-items: center; min-height: 60vh; }
        .spinner { width: 50px; height: 50px; border: 4px solid #e2e8f0; border-top-color: #1a3a6b; border-radius: 50%; animation: spin 1s linear infinite; }
        @keyframes spin { to { transform: rotate(360deg); } }
        @media (max-width: 768px) { .page-title { font-size: 28px; } }
      `}</style>
    </div>
  );
}
export default ExaminationSchedule;